import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const InlineCommentsQuery: GraphQLTaggedNode = graphql`
	query InlineCommentsQuery($pageId: ID!) @allowHigherTimeout {
		content(id: $pageId) {
			nodes {
				id
				type
				space {
					id
					operations {
						operation
						targetType
					}
				}
				operations {
					operation
					targetType
				}
			}
		}
		comments(pageId: $pageId, type: UNRESOLVED, depth: ROOT, first: 1000) {
			nodes {
				id
				body(representation: ATLAS_DOC_FORMAT) {
					value
				}
				contentStatus
				createdAt {
					value
				}
				createdAtNonLocalized
				links {
					webui
					editui
				}
				location {
					type
					... on InlineComment {
						inlineMarkerRef
						inlineText
						inlineResolveProperties {
							resolved
							isDangling
							resolvedFriendlyDate
							resolvedTime
							resolvedUser
						}
					}
					... on FooterComment {
						commentResolveProperties {
							resolved
							resolvedFriendlyDate
							resolvedTime
							resolvedUser
						}
					}
				}
				parentId
				permissions {
					isEditable
					isRemovable
					isResolvable
				}
				version {
					by {
						displayName
					}
					when
					number
				}
				author {
					displayName
					profilePicture {
						path
					}
					permissionType
					... on KnownUser {
						accountId
					}
				}
				replies {
					id
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					contentStatus
					createdAt {
						value
					}
					createdAtNonLocalized
					links {
						webui
						editui
					}
					location {
						type
						... on InlineComment {
							inlineMarkerRef
							inlineText
							inlineResolveProperties {
								resolved
								isDangling
								resolvedFriendlyDate
								resolvedTime
								resolvedUser
							}
						}
						... on FooterComment {
							commentResolveProperties {
								resolved
								resolvedFriendlyDate
								resolvedTime
								resolvedUser
							}
						}
					}
					parentId
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					version {
						by {
							displayName
						}
						when
						number
					}
					author {
						displayName
						profilePicture {
							path
						}
						permissionType
						... on KnownUser {
							accountId
						}
					}
				}
			}
		}
	}
`;
